import React from 'react';

import './About.css';

import {ReactComponent as YandexMapsBigImage} from "../../images/yandex-maps-big.svg";
import {ReactComponent as TwoGisMapsBigImage} from "../../images/2gis-maps-big.svg";
import {ReactComponent as ExternalIcon} from "../../images/icons/external.svg";
import AboutImage from '../../images/image2.jpg';
import About1Image from '../../images/image_about_1.png';
import About2Image from '../../images/image_about_2.png';
import About3Image from '../../images/image_about_3.png';
import About4Image from '../../images/image_about_4.jpeg';
import BlockForm from "../../components/BlockForm/BlockForm";
import Utils from "../../utils";


class AboutPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            images: [
                About3Image,
                About1Image,
                About2Image,
                About4Image,
            ],
            selectedIndex: 0
        }
    }

    componentDidMount() {
        Utils.setPageTitle('О нас')
    }

    render() {
        return <div className='about'>
            <div className='page'>
                <div className='block'>
                    <div className='title'>
                        О нас
                    </div>
                    <div className='gallery'>
                        <div className='description'>
                            Стоматологическая клиника «ЭСТЭЙ» работает в Омске с 2015 года. Мы оказываем все виды
                            стоматологической помощи в одной клинике — от лечения и хирургии до имплантации и ортопедии.
                        </div>
                        <div className='maps'>
                            <div className='card'>
                                <div className='top'>
                                    <YandexMapsBigImage/>
                                    <a href='https://yandex.com/maps/org/estei/1699146815/reviews/?ll=73.309824%2C54.983035&z=15'
                                       target='_blank' className='button'>
                                        Найти на карте
                                        <ExternalIcon/>
                                    </a>
                                </div>
                                <div className='label'>
                                    Отзывы на картах Яндекса
                                </div>
                            </div>
                            <div className='card'>
                                <div className='top'>
                                    <TwoGisMapsBigImage/>
                                    <a href='https://2gis.ru/omsk/firm/70000001018401753/tab/reviews' target='_blank'
                                       className='button'>
                                        Найти на карте
                                        <ExternalIcon/>
                                    </a>
                                </div>
                                <div className='label'>
                                    Отзывы на 2Гис
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='images'>
                    <img src={this.state.images[this.state.selectedIndex]} alt=''/>
                    <div className='list'>
                        <img className={this.state.selectedIndex === 0 ? 'selected' : ''} src={this.state.images[0]}
                             alt=''
                             onClick={() => this.setState({selectedIndex: 0})}/>
                        <img className={this.state.selectedIndex === 1 ? 'selected' : ''} src={this.state.images[1]}
                             alt=''
                             onClick={() => this.setState({selectedIndex: 1})}/>
                        <img className={this.state.selectedIndex === 2 ? 'selected' : ''} src={this.state.images[2]}
                             alt=''
                             onClick={() => this.setState({selectedIndex: 2})}/>
                        <img className={this.state.selectedIndex === 3 ? 'selected' : ''} src={this.state.images[3]}
                             alt=''
                             onClick={() => this.setState({selectedIndex: 3})}/>
                    </div>
                </div>
                <div className='description'>
                    <div className='label'>
                        Стоматологическая клиника «ЭСТЭЙ» в Омске предоставляет широкий спектр стоматологических услуг
                        для взрослых пациентов. В клинике ведут приём специалисты по терапевтическому, хирургическому,
                        ортопедическому и пародонтологическому лечению, что удобно пациентам и даёт гарантированный
                        отличный результат. Все основные этапы диагностики и лечения проводятся в одной клинике, что
                        позволяет выстраивать лечение последовательно и без лишних направлений.
                    </div>
                    <div className='label'>
                        Наша стоматология — это авторский медицинский проект, созданный практикующими
                        врачами-стоматологами с многолетним клиническим опытом. Клиника развивалась не как формальный
                        бизнес, а как профессиональная среда, в которой выстроены единые подходы к диагностике, лечению
                        и ответственности за результат.
                    </div>
                    <div className='label'>
                        Врачи работают по общим стандартам качества и вовлечены в процессы лечения на всех этапах, а не
                        только в рамках своего узкого направления.
                        Коллектив клиники сформирован из специалистов, для которых стоматология — не просто работа, а
                        осознанная профессиональная деятельность. Здесь ценят медицинскую этику, клиническое мышление и
                        непрерывное повышение квалификации. Такой подход обеспечивает стабильность команды,
                        преемственность решений и высокий уровень доверия со стороны пациентов.
                    </div>
                    <div className='label'>
                        При планировании лечения, особенно в сложных клинических ситуациях, специалисты клиники работают
                        коллегиально. Такой подход позволяет учитывать несколько профессиональных мнений и выбрать
                        оптимальный план лечения. При необходимости к работе привлекаются консультанты
                        стоматологического факультета ОмГМУ.
                    </div>
                </div>
                <div className='image'>
                    <img src={AboutImage} alt=''/>
                </div>
                <div className='description'>
                    <div className='label'>
                        Клиника имеет в структуре зуботехническую лабораторию, что даёт возможность изготавливать
                        ортопедические конструкции различной сложности в контролируемые сроки и с высокой точностью. Это
                        особенно важно при протезировании, лечении и имплантации.
                    </div>
                    <div className='label'>
                        В работе используются современные методы лечения и медицинское оборудование, соответствующее
                        требованиям современной стоматологии. Особое внимание уделяется вопросам безопасности пациентов:
                        строго соблюдаются санитарные нормы, принципы асептики и антисептики.
                    </div>
                    <div className='label'>
                        В клинике «ЭСТЭЙ» мы также уделяем особое внимание рациональной организации лечения и времени
                        пациентов. За счёт проведения диагностики, лечения, хирургических и ортопедических этапов в
                        одном месте путь от первичного приёма до результата выстраивается быстрее, чем при разрозненном
                        лечении в разных клиниках. Это позволяет сократить количество визитов, избежать повторных
                        консультаций и получить прогнозируемый результат в оптимальные сроки.
                    </div>
                    <div className='label'>
                        Стоматологическая клиника «ЭСТЭЙ» расположена в центре левобережья Омска, в районе с удобной
                        транспортной доступностью, что делает посещение клиники комфортным для пациентов из разных
                        районов города.
                    </div>
                </div>
            </div>
            <BlockForm addSnackbar={this.props.addSnackbar}/>
        </div>
    }
}


export default AboutPage;
